
/* =========================================================
   TECH BOUTIQUE — CART UPSELL V3.9
   Horizon AJAX Cart Drawer Refresh
   Preserve drawer, design and checkout buttons
   ========================================================= */

(() => {
  if (window.tbCartUpsellInitialized) return;
  window.tbCartUpsellInitialized = true;

  const SECTION_ID = 'cart-drawer-section';

  const root = () =>
    (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

  function setError(box, message) {
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
  }

  function clearError(box) {
    if (!box) return;
    box.textContent = '';
    box.hidden = true;
  }

  async function refreshDrawer() {
    const response = await fetch(
      `${root()}?sections=${SECTION_ID}`,
      {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Unable to refresh the cart.');
    }

    const sections = await response.json();
    const html = sections[SECTION_ID];

    if (!html) {
      throw new Error('Updated cart section is empty.');
    }

    const doc = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const newInner = doc.querySelector(
      '#cart-drawer .cart-drawer__inner'
    );

    const drawer = document.querySelector('#cart-drawer');

    const currentInner = drawer?.querySelector(
      '.cart-drawer__inner'
    );

    if (!newInner || !currentInner) {
      throw new Error('Updated drawer markup was not found.');
    }

    const currentContent = currentInner.querySelector(
      '.cart-drawer__content'
    );

    const scrollPosition = currentContent?.scrollTop || 0;

    /*
     * Replace inner content only.
     * Keep the existing open dialog and theme-drawer.
     */
    currentInner.replaceWith(newInner);

    const newContent = drawer.querySelector(
      '.cart-drawer__content'
    );

    if (newContent) {
      newContent.scrollTop = scrollPosition;
    }

    /*
     * Update cart badge in the drawer.
     */
    const cartResponse = await fetch(`${root()}cart.js`, {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (cartResponse.ok) {
      const cart = await cartResponse.json();

      const badge = drawer.querySelector(
        '.theme-drawer__badge'
      );

      if (badge) {
        badge.textContent = cart.item_count;
        badge.classList.toggle(
          'visually-hidden',
          cart.item_count === 0
        );
      }
    }
  }

  document.addEventListener(
    'click',
    async (event) => {
      const button = event.target.closest?.(
        '#cart-drawer [data-tb-upsell-add]'
      );

      if (!button || button.disabled) return;

      event.preventDefault();
      event.stopPropagation();

      const card = button.closest(
        '[data-tb-cart-upsell]'
      );

      const errorBox = card?.querySelector(
        '[data-tb-upsell-error]'
      );

      const variantId = Number(
        card?.dataset.variantId
      );

      if (!variantId) {
        setError(
          errorBox,
          'This product is unavailable.'
        );
        return;
      }

      const originalText = button.textContent;

      button.disabled = true;
      button.textContent = 'Adding to Your Bag...';
      clearError(errorBox);

      let added = false;

      try {
        const response = await fetch(
          `${root()}cart/add.js`,
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1
                }
              ]
            })
          }
        );

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            'Unable to add creatine.'
          );
        }

        added = true;
        button.textContent = '✓ Added to Your Bag';

        await refreshDrawer();

      } catch (error) {
        console.error(
          '[Tech Boutique Upsell]',
          error
        );

        if (added) {
          button.disabled = true;
          button.textContent = '✓ Added to Your Bag';

          setError(
            errorBox,
            'Creatine was added, but the cart display could not update. Please close and reopen your bag.'
          );
        } else {
          button.disabled = false;
          button.textContent = originalText;

          setError(
            errorBox,
            error.message ||
            'Something went wrong. Please try again.'
          );
        }
      }
    },
    true
  );
})();
